import styled from "styled-components";

export const PermissionsContainer = styled.div`
  padding: 45px 23px;
  display: flex;
  justify-content: center;
`;

export const MembersContainer = styled.div`
  padding: 45px 23px;
  padding-top: 0px;
`;
